import React, {useEffect, useRef, useState} from 'react'
import PaperComponent from "../../../components/MuiDraggableDialog";
import {Autocomplete, Chip, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, FormHelperText} from "@mui/material";
import {LocalizationProvider} from "@mui/x-date-pickers";
import {AdapterMoment} from "@mui/x-date-pickers/AdapterMoment";
import Avatar from "@mui/material/Avatar";
import Card from "@mui/material/Card";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";
import Button from "@mui/material/Button";
import {LoadingButton} from "@mui/lab";
import MDBox from "../../../components/MDBox";
import {noop} from "lodash";
import Grid from "@mui/material/Grid";
import {cargoOwnerInfo, cargoOwnerInfoReset} from "../../../actions/inventory/inventoryAction";
import {useDispatch, useSelector} from "react-redux";

import {Logout, onErrorAlert, onSuccessAlert} from "../../../actions";
import {useNavigate} from "react-router-dom";
import LocalStorage from "../../../utils/LocalStorage";
import {useTranslation} from "react-i18next";
import AddressesInformation from "./AddressesInformation";
import OwnerCargoOperationDetail from "./OwnerCargoOperationDetail";
import OwnerCargoInfo from "./OwnerCargoInformation";
import UserCarrierEdit from "../../profile/userInformation/UserCarrierEdit";
import OwnerDiscountInformation from "./OwnerCargoInformation/OwnerDiscountInformation";
import MDTypography from "../../../components/MDTypography";
import PaymentTermEdit from "./OwnerCargoInformation/PaymentTermEdit";
import {
    cargoOwnerAddressList,
    cargoOwnerDiscountList,
    cargoOwnerModifyMainInfo
} from "../../../actions/customer/customerAction";

import {v4 as uuidv4} from "uuid";
import moment from "moment";
import MDInput from "../../../components/MDInput";
import {MuiDatePicker} from "../../../components/MuiDatePicker";
import api from "../../../api/api";
import {checkPermission, PERMISSION_DICT} from "../../../utils/Users_Roles_Permission";
import * as yup from "yup";

const creditStatusOptions = ['ACTIVE', 'INACTIVE', 'USING']
const paymentTermOptions = ['CREDIT', 'CREDIT_CARD', 'NET_7', 'NET_15', 'NET_30', 'DUE ON RECEIPT']
const invoiceTermOptions = [
    {value: '1', label: '1-Daily Settlement'},
    {value: '7', label: '7-Weekly Settlement'},
    {value: '15', label: '15- Semimonthly Settlement'},
    {value: '30', label: '30- Monthly Settlement'}
]
const getInvoiceTermLabel = (value) => {
    if (value === null || value === undefined || value === '') return ''

    const text = value.toString().trim()

    const option = invoiceTermOptions.find(
        item => item.value === text || item.label === text
    )

    return option?.label || text
}
const getInvoiceTermValue = (value) => {
    if (!value) return ''
    const text = value.toString().trim()
    const invoiceTermAlias = {
        'daily settlement': '1',
        'weekly settlement': '7',
        'semimonthly settlement': '15',
        'monthly settlement': '30'
    }
    if (invoiceTermAlias[text.toLowerCase()]) return invoiceTermAlias[text.toLowerCase()]
    const matchedOption = invoiceTermOptions.find((option) =>
        option.value === text ||
        option.label === text ||
        option.label.toLowerCase().includes(text.toLowerCase())
    )
    return matchedOption?.value || text
}
const splitSendEmails = (value) => (
    value
        ?.split(/[,;\n]+/)
        .map((email) => email.trim())
        .filter(Boolean) || []
)
const getSendEmailSchema = (t) => yup.string().trim().email(t('CustomerPage.Email must be a valid email'))
const validateSendEmail = (email, t) => getSendEmailSchema(t).isValidSync(email)

const CreditInformation = ({info, loading}) => {
    const {t} = useTranslation();
    const [isOpen, setIsOpen] = useState(true)

    const formatDate = (value) => value ? moment(value).format('YYYY-MM-DD') : ''

    const renderInfoItem = (label, value, gridProps = {xs: 12, md: 6, lg: 2.4}) => (
        <Grid item mb={1} {...gridProps}>
            <MDBox>
                <MDTypography variant="button" fontWeight="medium" gutterBottom>
                    {label}:
                </MDTypography>
            </MDBox>
            <MDBox>
                <MDTypography variant="button" color="text" fontWeight="regular">
                    {value}
                </MDTypography>
            </MDBox>
        </Grid>
    )

    return (
        <Card sx={{minWidth: 350}}>
            <MDBox
                mx={1}
                mt={-3}
                py={1}
                px={2}
                variant="gradient"
                bgColor="light"
                borderRadius="lg"
                coloredShadow="light"
                display={'flex'}
                alignItems={'center'}
                justifyContent={'space-between'}
            >
                <MDTypography variant="h6">
                    {t('CustomerPage.Credit Information', 'Credit Information')}
                </MDTypography>
                <IconButton color={'white'} disabled={loading} size={'small'} onClick={() => setIsOpen(!isOpen)}>
                    {(isOpen && !loading) ? <Icon>expand_less</Icon> : <Icon>expand_more</Icon>}
                </IconButton>
            </MDBox>
            <Collapse in={isOpen && !loading} timeout={500}>
                <MDBox pt={1} pb={2} px={2}>
                    <Grid container xs={12} display="flex" p={0} m={0}>
                        {renderInfoItem(t('CustomerPage.Credit Status', 'Credit Status'), info?.creditStatus)}
                        {renderInfoItem(t('CustomerPage.Credit Start Time', 'Credit Start Time'), formatDate(info?.creditStartTime))}
                        {renderInfoItem(t('CustomerPage.Credit End Time', 'Credit End Time'), formatDate(info?.creditEndTime))}
                        {renderInfoItem(t('CustomerPage.QB CAD Customer ID', 'QB CAD Customer ID'), info?.qbCustomerId)}
                        {renderInfoItem(t('CustomerPage.QB USD Customer ID', 'QB USD Customer ID'), info?.qbUsdCustomerId)}
                        {renderInfoItem(t('CustomerPage.Payment Term'), info?.paymentTerm)}
                        {renderInfoItem(
                        t('CustomerPage.Invoice Term'),
                        getInvoiceTermLabel(info?.settlementPeriod || info?.invoiceTerm)
                        )}
                        {renderInfoItem(t('CustomerPage.Credit Change Log', 'Credit Change Log'), info?.creditChangeLog, {xs: 12, md: 12, lg: 12})}
                    </Grid>
                </MDBox>
            </Collapse>
        </Card>
    )
}

const OwnerCargoMainInfoEdit = ({info, editInfo, setEditInfo, editErrors = {}, setEditErrors}) => {
    const {t} = useTranslation();
    const darkMode = useSelector(state => state?.common?.darkMode,(prev, next) => prev === next)
    const [sendEmailInput, setSendEmailInput] = useState('')
    const sendEmailInputRef = useRef(null)

    const formatDate = (value) => value ? moment(value).format('YYYY-MM-DD') : ''
    const getOptionValue = (option) => typeof option === 'object' ? option?.value : option
    const getOptionLabel = (option) => typeof option === 'object' ? option?.label : option
    const findOption = (options, value) => options.find((option) => getOptionValue(option) === value) || null
    const updateEditInfo = (field, value) => {
        setEditInfo((prev) => ({
            ...prev,
            [field]: value
        }))
        if (editErrors?.[field] && setEditErrors) {
            setEditErrors((prev) => ({
                ...prev,
                [field]: ''
            }))
        }
    }

    const renderSelectItem = (label, field, options) => (
        <Grid item xs={12} md={6} mb={2} sx={{minWidth: {xs: 250, md: 350}}}>
            <FormControl fullWidth>
                <Autocomplete
                    disablePortal={false}
                    value={findOption(options, editInfo?.[field])}
                    onChange={(event, value) => updateEditInfo(field, getOptionValue(value) || '')}
                    options={options}
                    getOptionLabel={(option) => getOptionLabel(option)}
                    isOptionEqualToValue={(option, value) => getOptionValue(option) === getOptionValue(value)}
                    renderInput={(params) => (
                        <MDInput
                            {...params}
                            label={label}
                            fullWidth
                            InputLabelProps={{shrink: true}}
                        />
                    )}
                />
                <FormHelperText sx={{fontWeight: 'medium'}} />
            </FormControl>
        </Grid>
    )

    const renderInputItem = (label, field, inputProps = {}) => (
        <Grid item xs={12} md={6} mb={2} sx={{minWidth: {xs: 250, md: 350}}}>
            <FormControl fullWidth>
                <MDInput
                    label={label}
                    fullWidth
                    value={editInfo?.[field] || ''}
                    onChange={(event) => updateEditInfo(field, event.target.value)}
                    InputLabelProps={{shrink: true}}
                    error={!!editErrors?.[field]}
                    {...inputProps}
                />
                <FormHelperText sx={{fontWeight: 'medium'}}>{editErrors?.[field] || ''}</FormHelperText>
            </FormControl>
        </Grid>
    )

    const updateSendEmails = (field, value) => {
        const emails = value.flatMap((item) => splitSendEmails(item))
        updateEditInfo(field, Array.from(new Set(emails)).join(','))
    }

    const commitSendEmailInput = (field) => {
        const emails = splitSendEmails(sendEmailInput)
        if (emails.length === 0) return
        updateSendEmails(field, [...splitSendEmails(editInfo?.[field]), ...emails])
        setSendEmailInput('')
    }

    const renderEmailTagsItem = (label, field) => (
        <Grid item xs={12} md={6} mb={2} sx={{minWidth: {xs: 250, md: 350}}}>
            <FormControl fullWidth error={!!editErrors?.[field]}>
                <Autocomplete
                    multiple
                    freeSolo
                    options={[]}
                    value={splitSendEmails(editInfo?.[field])}
                    inputValue={sendEmailInput}
                    onInputChange={(event, value) => setSendEmailInput(value)}
                    onChange={(event, value) => updateSendEmails(field, value)}
                    renderTags={(value, getTagProps) =>
                        value.map((option, index) => (
                            <Chip
                                size="small"
                                color={validateSendEmail(option, t) ? 'primary' : 'error'}
                                variant="outlined"
                                label={option}
                                {...getTagProps({index})}
                            />
                        ))
                    }
                    renderInput={(params) => (
                        <MDInput
                            {...params}
                            label={label}
                            fullWidth
                            error={!!editErrors?.[field]}
                            placeholder={t('CustomerPage.Enter email and press Enter', 'Enter email and press Enter')}
                            InputLabelProps={{shrink: true}}
                            inputRef={sendEmailInputRef}
                            onBlur={() => commitSendEmailInput(field)}
                            onKeyDown={(event) => {
                                if (event.key === ',') {
                                    event.preventDefault()
                                    commitSendEmailInput(field)
                                }
                            }}
                        />
                    )}
                />
                <FormHelperText error={!!editErrors?.[field]} sx={{fontWeight: 'medium'}}>
                    {editErrors?.[field] || ''}
                </FormHelperText>
            </FormControl>
        </Grid>
    )

    const renderDateItem = (label, field) => (
        <Grid item xs={12} md={6} mb={2} sx={{minWidth: {xs: 250, md: 350}}}>
            <LocalizationProvider dateAdapter={AdapterMoment}>
                <MuiDatePicker
                    label={label}
                    value={editInfo?.[field] ? moment(editInfo?.[field]) : null}
                    onChange={(newValue) => {
                        updateEditInfo(field, newValue ? newValue.format('YYYY-MM-DD') : '')
                    }}
                    slotProps={{
                        textField: {
                            fullWidth: true,
                            inputProps: {
                                readOnly: true,
                            },
                            InputLabelProps: {
                                shrink: true,
                            },
                        },
                    }}
                />
            </LocalizationProvider>
        </Grid>
    )

    const renderReadonlyItem = (label, value) => (
        <Grid item xs={12} md={6} mb={2} sx={{minWidth: {xs: 250, md: 350}}}>
            <FormControl fullWidth>
                <MDInput
                    label={label}
                    fullWidth
                    disabled
                    value={value || ''}
                    InputLabelProps={{shrink: true}}
                />
                <FormHelperText sx={{fontWeight: 'medium'}} />
            </FormControl>
        </Grid>
    )

    return (
        <MDBox pt={2} pb={2} px={3} sx={{display: 'flex', justifyContent: 'space-between', flexDirection: 'column'}}>
            <Grid container spacing={2} sx={{display: 'flex', alignItems: 'flex-start'}}>
                <Grid item xs={12} md={12} mb={2} sx={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                    <Avatar sx={darkMode ? {bgcolor: 'whitesmoke'} : {bgcolor: '#7b809a'}}>
                        <Icon>person_add</Icon>
                    </Avatar>
                </Grid>
                {renderReadonlyItem(t('CustomerPage.Cargo Owner ID'), info?.ocpOwnerId)}
                {renderSelectItem(t('CustomerPage.Credit Status', 'Credit Status'), 'creditStatus', creditStatusOptions)}
                {renderReadonlyItem(t('CustomerPage.Credit Start Time', 'Credit Start Time'), formatDate(info?.creditStartTime))}
                {renderDateItem(t('CustomerPage.Credit End Time', 'Credit End Time'), 'creditEndTime')}
                {renderInputItem(t('CustomerPage.QB CAD Customer ID', 'QB CAD Customer ID'), 'qbCustomerId')}
                {renderInputItem(t('CustomerPage.QB USD Customer ID', 'QB USD Customer ID'), 'qbUsdCustomerId')}
                {renderSelectItem(t('CustomerPage.Payment Term'), 'paymentTerm', paymentTermOptions)}
                {renderSelectItem(t('CustomerPage.Invoice Term'), 'invoiceTerm', invoiceTermOptions)}
                {renderEmailTagsItem(t('CustomerPage.Send Email', 'Send Email'), 'sendEmail')}
            </Grid>
        </MDBox>
    )
}

const OwnerCargoPreviewer = ({isOpen, setIsOpen, type = 'Preview', setType, data = {}}) => {
    const {t, i18n} = useTranslation();
    const dispatch = useDispatch()
    const [ownerResp,setOwnerResp] = useState({})
    const [addressList,setAddressList] = useState([])
    const [discountList,setDiscountList] = useState([])
    const [addressData,setAddressData] = useState(null)
    const [discountData,setDiscountData] = useState({})
    const [loading, setLoading] = useState(true)
    const nav = useNavigate()
    const [openCarrierEdit,setOpenCarrierEdit] = useState(false)
    const [openStorageFeeTermEdit,setOpenStorageFeeTermEdit] = useState(false)
    const [list,setList] = useState([])
    const [total,setTotal] = useState(0)
    const [editInfo, setEditInfo] = useState({})
    const [editErrors, setEditErrors] = useState({})
    const [loadingButtonState, setLoadingButtonState] = useState(false)
    const buildEditInfo = (info) => ({
        creditStatus: info?.creditStatus || '',
        creditStartTime: info?.creditStartTime ? moment(info?.creditStartTime).format('YYYY-MM-DD') : '',
        creditEndTime: info?.creditEndTime ? moment(info?.creditEndTime).format('YYYY-MM-DD') : '',
        qbCustomerId: info?.qbCustomerId || '',
        qbUsdCustomerId: info?.qbUsdCustomerId || '',
        paymentTerm: info?.paymentTerm || '',
        invoiceTerm: getInvoiceTermValue(info?.settlementPeriod || info?.invoiceTerm),
        sendEmail: info?.sendEmail || ''
    })
    const onInfoSuccess = (detailData) => {
        setAddressList(detailData?.addresses)
        setOwnerResp(detailData?.ownerResp)
        setDiscountList(detailData?.ownerFeeDiscountInfos)
        setLoading(false)
    }

    useEffect(() => {
        setEditInfo(buildEditInfo(ownerResp))
    }, [ownerResp])

    useEffect(()=>{
        if(!isOpen){
            setOwnerResp({})
            setAddressList([])
            setDiscountData({})
            setAddressData({})
            setEditErrors({})
        }
    },[isOpen])

    const onError = (msg,code) => {
        dispatch(onErrorAlert(t(msg)))
        setLoading(false)
        if (code === 401) {
            dispatch(Logout(noop))
            nav('/')
        }
    }

    const onDiscountSuccess = (data) => {
        setList( data?.rows.map((item, index) => {
            return { ...item, id: uuidv4() };
        }))
        setTotal(data?.total)
        // setDiscountData(data)
    }

    const onAddressSuccess = (data) => {
        setAddressData(data)
    }

    useEffect(() => {

        if(isOpen){

            const axiosPost= async () => {
                let formData = {}
                formData.ownerId = data?.ocpOwnerId
                formData.userName = LocalStorage.getItem('username')
                formData.pageNum = 1
                formData.pageSize = 5
                setLoading(true)
                await dispatch(cargoOwnerDiscountList(formData,onDiscountSuccess,onError))
                await dispatch(cargoOwnerAddressList(formData,onAddressSuccess,onError))
                await dispatch(cargoOwnerInfo(formData, onInfoSuccess,onError))
            }
            axiosPost().then()
        }

    }, [isOpen])
    const getDiscountList = (pageSize,pageNum)=>{
        const axiosPost= async () => {
            let formData = {}
            formData.ownerId = data?.ocpOwnerId
            formData.userName = LocalStorage.getItem('username')
            formData.pageNum = pageNum
            formData.pageSize = pageSize
            setLoading(true)
            await dispatch(cargoOwnerDiscountList(formData,(data)=>{
                onDiscountSuccess(data)
                setLoading(false)
            },onError))
            // await dispatch(cargoOwnerAddressList(formData,onAddressSuccess,onError))
            // await dispatch(cargoOwnerInfo(formData, onInfoSuccess,onError))
        }
        axiosPost().then()
    }

    const handleCloseModal = () => {
        setLoading(true)
        setIsOpen(false)
        setType('Preview')
        dispatch(cargoOwnerInfoReset())
    }

    const refreshOwnerInfo = async () => {
        let formData = {}
        formData.ownerId = data?.ocpOwnerId
        formData.userName = LocalStorage.getItem('username')
        formData.pageNum = 1
        formData.pageSize = 5
        await dispatch(cargoOwnerInfo(formData, onInfoSuccess,onError))
    }

    const handleSubmit = async () => {
        const formatDateTime = (value) => value ? moment(value).format('YYYY-MM-DD HH:mm:ss') : ''
        const sendEmails = splitSendEmails(editInfo?.sendEmail)
        const invalidEmails = sendEmails.filter((email) => !validateSendEmail(email, t))
        if (invalidEmails.length > 0) {
            setEditErrors({
                sendEmail: `${t('CustomerPage.Email must be a valid email')}: ${invalidEmails.join(', ')}`
            })
            return
        }
        const sendEmail = sendEmails.join(';')
        setEditErrors({})
        const formData = {
            ocpOwnerId: ownerResp?.ocpOwnerId,
            creditStatus: editInfo?.creditStatus || '',
            creditStartTime: formatDateTime(editInfo?.creditStartTime),
            creditEndTime: formatDateTime(editInfo?.creditEndTime),
            qbCustomerId: editInfo?.qbCustomerId || '',
            qbUsdCustomerId: editInfo?.qbUsdCustomerId || '',
            paymentTerm: editInfo?.paymentTerm || '',
            invoiceTerm: editInfo?.invoiceTerm || '',
            sendEmail
        }

        setLoadingButtonState(true);

        await dispatch(
            cargoOwnerModifyMainInfo(
                formData,
                async () => {
                    dispatch(
                        onSuccessAlert(
                            t(
                                "CustomerPage.Cargo Owner Edit Successfully.",
                                "Cargo Owner Edit Successfully."
                            )
                        )
                    );

                    await refreshOwnerInfo();
                    setType("Preview");
                    setLoadingButtonState(false);
                },
                (msg, code) => {
                    onError(msg, code);
                    setLoadingButtonState(false);
                }
            )
        );
    }

    return(<React.Fragment>
        <Dialog
            open={isOpen}
            onClose={handleCloseModal}
            PaperComponent={PaperComponent}
            aria-labelledby="draggable-dialog-title"
            scroll={'paper'}
            fullWidth={true}
            maxWidth={'xxl'}
            sx={{
                maxHeight: "100vh", // 限制 Dialog 最大高度
                overflow: "hidden", // 避免外部滚动条
                "& .MuiDialog-paper": {
                    maxHeight: "100vh", // 让 Dialog 内部 Paper 也受限
                    overflow: "hidden", // 避免不必要的外部滚动条
                },
            }}
        >

            <MDBox component="form" role="form" >
                <DialogTitle style={{cursor: 'move', display: 'flex', justifyContent: 'space-between',position: "sticky",
                    alignItems: "center",
                    top: 0,
                    zIndex: 1100,
                    boxShadow: 'rgba(17, 17, 26, 0.05) 0px 1px 0px, rgba(17, 17, 26, 0.1) 0px 0px 8px',
                }}
                            >
                    <Grid container>
                        <Grid item lg={8} md={12}>
                            {type === 'Preview' &&<div> {`${t('CustomerPage.Cargo Owner ID')}: ${data?.ocpOwnerId}`}</div>}
                            {type === 'Edit' &&<div> {`${t('CustomerPage.Edit Cargo Owner', 'Edit Cargo Owner')}: ${data?.ocpOwnerId}`}</div>}
                        </Grid>
                        <Grid item lg={4} md={12} sx={{width: '100%'}}>
                            <div style={{
                                display: 'flex',
                                justifyContent: 'flex-end'
                            }}>
                                {
                                    type === 'Preview' && checkPermission(PERMISSION_DICT.CustomerCargoModifyMainInfo) &&
                                    <IconButton
                                        color='primary'
                                        disabled={loading}
                                        onClick={() => {
                                            setType('Edit')
                                            setIsOpen(true)
                                        }}>
                                        <Icon>edit</Icon>
                                    </IconButton>
                                }
                                <IconButton size="medium" onClick={handleCloseModal}>
                                    <Icon>cancel</Icon>
                                </IconButton>
                            </div>
                        </Grid>
                    </Grid>
                </DialogTitle>
                <DialogContent sx={{
                    maxHeight: "80vh", // 限制最大高度，防止 Dialog 过长
                    overflowY: "auto", // 允许滚动
                }} >
                    <DialogContentText>
                        {
                            type === 'Edit' ? (
                                <OwnerCargoMainInfoEdit
                                    info={ownerResp}
                                    editInfo={editInfo}
                                    setEditInfo={setEditInfo}
                                    editErrors={editErrors}
                                    setEditErrors={setEditErrors}
                                />
                            ) : (
                                <MDBox mb={3} p={3}>
                                    <Grid container spacing={3} flexDirection={'row'} alignItems={'start'}>
                                        <Grid item xs={12}   mt={2}>
                                            <OwnerCargoInfo info={ownerResp}
                                                            openCarrierEdit={openCarrierEdit}
                                                            setOpenCarrierEdit={setOpenCarrierEdit}
                                                            setOpenStorageFeeTermEdit={setOpenStorageFeeTermEdit}
                                                            loading={loading}
                                            />
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12} mt={5}>
                                        <CreditInformation
                                            info={ownerResp}
                                            loading={loading}
                                        />
                                    </Grid>
                                    <Grid item container xs={12}  spacing={1} >
                                        <Grid item xs={12} mt={5}>
                                            <Grid item xs={12}>
                                                <OwnerDiscountInformation info={ownerResp}
                                                                          loading={loading}
                                                                          setTotal={setTotal}
                                                                          total={total}
                                                                          setList={setList}
                                                                          list={list}
                                                /></Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item container xs={12}  spacing={1} >
                                        <Grid item xs={12} mt={5}>
                                            <Grid item xs={12}>
                                                <AddressesInformation
                                                    info={ownerResp}
                                                    addressData={addressData}
                                                    loading={loading}/>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12} mt={5}>
                                        <OwnerCargoOperationDetail info={ownerResp}
                                                                   loading={loading}/>
                                    </Grid>
                                </MDBox>
                            )
                        }
                    </DialogContentText>
                </DialogContent>
                {
                    type !== 'Preview' &&
                    <DialogActions>
                        <Button disabled={loadingButtonState} onClick={() => {
                            setEditInfo(buildEditInfo(ownerResp))
                            setEditErrors({})
                            setType('Preview')
                        }}>
                            {t(`Cancel`)}
                        </Button>
                        <LoadingButton
                            loading={loadingButtonState}
                            onClick={handleSubmit}>
                            {t('Submit')}
                        </LoadingButton>
                    </DialogActions>
                }
            </MDBox>
        </Dialog>
        <UserCarrierEdit setOpen={setOpenCarrierEdit} open={openCarrierEdit} parent={"cargoOwner"} owner={data?.ocpOwnerId} />
        <PaymentTermEdit setOpen={setOpenStorageFeeTermEdit} open={openStorageFeeTermEdit} onInfoSuccess={onInfoSuccess}/>

    </React.Fragment>)
}

export default OwnerCargoPreviewer
